<template>
  <div id="seal">
    <el-card class="index" >
      <div class="menu">
        <el-menu :default-active="$route.name" :key="key" class="el-menu-demo" mode="horizontal" @select="SelectMenu"
          >
          <el-menu-item v-for="(item, index) in targetRoutes" :key="index" :index="item.path">
            {{ item.meta.title }}
          </el-menu-item>
        </el-menu>
      </div>
      <el-button
          class="btn"
            type="success"
            @click="enter()"
            v-if="
              this.$store.state.rolesname.includes('bankruptcyManagerInput')
            "
          >
            录入
          </el-button>
          <!-- 折腾跳转是出现的文字 -->
          <div class="kb"></div>
          <div class="xian"></div>
          <router-view ></router-view>

    </el-card>
 

    <el-dialog
      title="详情"
      :visible.sync="detailsDialog"
      width="80%"
      style="text-align: center"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formref"
        label-width="150px"
        class="demo-form"
      >
        <el-form-item label="破产企业名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="代理律师(主)" prop="leadLawyer">
              <el-select
                style="width: 100%"
                v-model="form.leadLawyer"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                @change="LeadLawyerChange(form.leadLawyer)"
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理律师(副)" prop="coCounsel">
              <el-select
                style="width: 100%"
                v-model="form.coCounsel"
                placeholder="请选择"
                class="select"
                clearable
                multiple
                filterable
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="破产项目来源" prop="soure">
              <el-select
                style="width: 100%"
                v-model="form.soure"
                placeholder="请选择"
                class="select"
                clearable
                filterable
              >
                <el-option
                  v-for="item in SoureOptions"
                  :key="item.nikename"
                  :label="item.label"
                  :value="item.nikename"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收案日期" prop="approvaldate">
              <div
                class="date_box"
                @mouseover="onMouseOver()"
                @mouseleave="onMouseleave()"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="form.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                  clearable
                >
                </el-date-picker>
                <i class="el-icon-date" ref="iconDate"></i>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="部门审批人"
              prop="caseLeaders"
              key="caseLeaders"
            >
              <el-select
                style="width: 100%"
                v-model="form.caseLeaders"
                placeholder="请选择"
                class="select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二次审批人" prop="level">
              <el-select
                style="width: 100%"
                v-model="form.level"
                placeholder="请选择"
                class="select"
                clearable
                filterable
              >
                <el-option
                  v-for="item in Level"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select
            style="width: 100%"
            v-model="form.sealtype"
            placeholder="请选择"
            class="select"
            clearable
            filterable
          >
            <el-option
              v-for="item in Seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div style="text-align: center">
            <el-button type="primary" @click="inputCase('formref')"
              >确认提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  caseLawyerApi,
  bkInsert,
  caseInsertMenu,
  bkSelect
} from '../../api/case'
import { GetDepartmentLeaders } from '../../api/bankrupt'
import { user } from '../../api/seal'
export default {
  name: 'case',
  // components:{
  //   Table
  // },
  data() {
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == '' || value == []) {
        callback(new Error('请输入或选择！'))
      }
      callback()
    }
    return {
      // isIndex: false,
      status: '',
      list: [],
      loading: false,
      statusOptions: [],
      enterForm: {},
      menu: true,

      form: {
        name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null
      },

      rules: {
        name: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        leadLawyer: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        soure: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        approvaldate: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        caseLeaders: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        level: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        sealtype: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ]
      },

      SoureOptions: [
        { label: '投标', nikename: '投标' },
        { label: '指定', nikename: '指定' }
      ],
      // 代理律师
      Lawyer: [],
      // 部门审批人
      CaseLeaders: [],
      // 二次审批人
      Level: [],
      // 用章类型
      Seal: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' }
      ],
      detailsDialog: false
    }
  },
  async created() {
    await this.GetInsertMenu()
    await this.GetLawyer()
    this.LeadLawyerChange(this.form.leadLawyer)
  },
  methods: {
    // 查询
    bkCase() {
      bkSelect({
        name: null,
        leadLawyer: null,
        soure: null,
        starttime: null,
        endtime: null,
        status: null,
        page: this.currentPage,
        rows: this.pageSize
      })
        .then((res) => {
          if (res.data.status == 0) {
            this.total = parseInt(res.data.message)
            this.tableData = res.data.data
            // console.log('查询成功', res.data.data)
          }
        })
        .catch((err) => {
          console.log('查询失败', err)
        })
    },
    enter() {
      this.detailsDialog = true
    },
    async GetInsertMenu() {
      await caseInsertMenu({}).then((res) => {
        if (res.data.status == 'success') {
          this.statusOptions = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    SelectMenu(item) {
      this.$store.commit('setPage', 1)
      this.$router.push({
        query: {
          guid: this.$route.query.guid,
          status: this.$route.query.status,
          caseType: this.$route.query.caseType,
          mystatus: this.$route.query.mystatus,
          type: this.$route.query.type
        },
        path: item
      })
    },
    //确认提交
    inputCase(formref) {
      this.$refs[formref].validate((valid) => {
        if (valid) {
          bkInsert({
            name: this.form.name,
            leadLawyer: this.form.leadLawyer,
            coCounsel: this.form.coCounsel,
            soure: this.form.soure,
            approvaldate: this.form.approvaldate,
            caseLeaders: this.form.caseLeaders,
            level: this.form.level,
            sealtype: this.form.sealtype
          })
            .then((res) => {
              if (res.data.status == 0) {
                this.$message.success(res.data.message)
                this.bkCase()
              } else {
                this.$message.error(res.data.message)
              }
              this.$refs[formref].resetFields()
             
            })
            .catch(() => {
              this.$message.error('前台错误！')
            })
          this.detailsDialog = false
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('请检查案件信息填写错误!')
        }
      })
    },
    // 代理律师/申请人/代理律师
    async GetLawyer() {
      await caseLawyerApi({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data.filter((item) => item.status == 0||item.status==6)
          // this.Lawyer = res.data.data
          this.form.leadLawyer = res.data.data[0].uid
          this.form.applicant = res.data.data[0].uid
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取案件审核部门主管
    GetDepartmentLeaders(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }

      GetDepartmentLeaders({
        Id: lvshi
      }).then((res) => {
        if (res.data.status == '0') {
          this.CaseLeaders = res.data.data
          var index = this.CaseLeaders.findIndex((item) => {
            return item.value == this.form.caseLeaders
          })
          // console.log("index:"+index)
          if (index == -1) {
            //不存在，清空
            this.form.caseLeaders = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 案件二次审批人/用章二次审批人
    GetLevel(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      user({
        Id: this.form.leadLawyer,
        apporver: 'case_00000000-0011-0011-0012-000000000000'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Level = res.data.data
          var index = this.Level.findIndex((item) => {
            return item.id == this.form.level
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.level = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 代理律师 改变
    LeadLawyerChange(lvshi) {
      this.GetDepartmentLeaders(lvshi)
      this.GetLevel(lvshi)
    },
    onMouseOver() {
      if (this.form.approvaldate != undefined && this.form != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    }
  },
  filters: {
    getRouterActive(path) {
      let str = path.split('/')
      return str[3]
    }
  },
  computed: {
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/bankruptcy' //遍历每一个数组，过滤出返回值委true的值
      )
      var tar = target[0].children.filter((el) => el.hidden != true)
      // console.log('tar', tar)
      return tar
    },
    key() {
      return this.$route.name
    }
  }
}
</script>
<style lang="less" scoped>
#seal .index {
  width: 100%;
  margin: auto;
  border-radius: 16px;
  position: relative;
 
}

#seal .el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

#seal .el-menu.el-menu--horizontal {
  border-bottom: none;
}

#seal .menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#seal /deep/.el-card__body,
#seal .el-main {
  padding: 0px;
  padding-bottom: 20px;

}

#seal .xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;

}

#seal .btn {
  position: absolute;
  top: 8px;
  right: 2%;
  z-index: 2;
  // position:absolute;
  // top:130px;
  // right: 2%;
}

#seal .kb {
  width: 98px;
  height: 48px;
  position: absolute;
  top: 8px;
  right: 2%;
  background: #fff;
  z-index: 1;
}
.date_box {
    .el-icon-date {
      position: absolute;
      top: 50%;
      right: 10px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }

    /deep/ .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }
  
  </style>